export default __webpack_public_path__ + "static/media/question mark square 1.81f956a7.svg";